import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 border border-accent-200/60 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-fire-line text-sm"></i>
            热点专题
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点爆料专题</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">精选近期最具话题性和关注度的娱乐爆料专题，全方位呈现事件全貌。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.summary}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {item.hot}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}